import React from 'react';
import NumberedList from '../../../Elements/NumberedList';

const items = [
  'The first ready job of a month makes that month’s draft.',
  'Every morning after that, Bravo adds the new ready jobs to it.',
  'The draft always gets the same bill-to contact, PO number, currency and invoice form.',
  'A person checks the draft and finalizes it, as today.',
];

function NumberedListDemoComponent() {
  return <NumberedList items={items} />;
}

export const numberedListDemo = {
  id: 'numbered-list',
  title: 'Numbered list',
  category: 'Basics',
  importPath: 'Elements/NumberedList',
  notes: [
    'Steps or points in order, each with its number in a circle, such as a "how it works" list.',
    'items are the texts, strings or elements, in their order.',
  ],
  snippet: '<NumberedList items={["First this.", "Then that."]} />',
  render: NumberedListDemoComponent,
};
